import { useState } from 'react';
import { Input, Button, Tag, Space } from 'antd';

function RemoveTagsInput({ value, onChange }) {
  const [inputValue, setInputValue] = useState('');

  const addTag = () => {
    const newTag = inputValue.trim();
    if (newTag && !value.includes(newTag)) {
      onChange([...value, newTag]);
      setInputValue('');
    }
  };

  const removeTag = (tagToRemove) => {
    onChange(value.filter(tag => tag !== tagToRemove));
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addTag();
    }
  };

  return (
    <div>
      <Space wrap style={{ marginBottom: 8 }}>
        {value.map(tag => (
          <Tag
            key={tag}
            closable
            onClose={() => removeTag(tag)}
            color="blue"
          >
            {tag}
          </Tag>
        ))}
      </Space>
      <Space>
        <Input
          placeholder="Add tag..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          style={{ width: 200 }}
        />
        <Button type="primary" onClick={addTag}>+</Button>
      </Space>
    </div>
  );
}

export default RemoveTagsInput;
